import { useEffect, useState } from 'react';

/**
 * Hero de secteur: grande photo sombre à zoom lent, aplat translucide froid en biais à droite,
 * petit titre dont le trait part du bord gauche de l'écran, et grand titre qui monte dans un masque.
 */
export default function SectorHero({ image, title }: { image?: string; title: string }) {
  const [seen, setSeen] = useState(false);
  useEffect(() => {
    const id = requestAnimationFrame(() => setSeen(true));
    return () => cancelAnimationFrame(id);
  }, []);

  return (
    <section data-seen={seen} className="relative h-[32rem] overflow-hidden bg-charcoal text-white md:h-[calc(100svh-5.5rem)] md:max-h-[46rem] md:min-h-[34rem]">
      {image && <img src={image} alt="" className="zoom-slow absolute inset-0 h-full w-full object-cover" />}
      <div className="absolute inset-0 bg-black/45" />
      <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
      <svg aria-hidden viewBox="0 0 1440 812" preserveAspectRatio="xMaxYMid slice" className="sh-shape pointer-events-none absolute inset-0 hidden h-full w-full lg:block">
        <polygon points="1000,120 1350,120 1440,210 1440,590 1350,590" fill="#fff" fillOpacity="0.09" />
        <polygon points="1350,120 1440,210 1440,590 1350,590" fill="var(--color-steel-soft)" fillOpacity="0.14" />
        <polyline points="1000,120 1350,590" fill="none" stroke="var(--color-steel-soft)" strokeOpacity="0.55" strokeWidth="2" />
      </svg>

      <div className="site-container relative flex h-full flex-col justify-end pb-12 md:pb-20">
        <div className="relative inline-block w-fit">
          <span aria-hidden className="sh-eyebrow-line absolute right-[calc(100%+1.5rem)] top-1/2 h-[0.13rem] w-[100vw] -translate-y-1/2 bg-brand" />
          <div className="cs-eyebrow text-xs font-semibold uppercase tracking-[0.1rem] text-white"><span className="cs-eyebrow-text inline-block">Secteur</span></div>
        </div>
        <div className="cs-mask mt-5 max-w-4xl pb-2">
          <h1 className="cs-title font-display text-[2.75rem] font-bold normal-case leading-[1.02] tracking-normal text-white md:text-[5rem]" style={{ display: '-webkit-box', WebkitLineClamp: 3, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>{title}</h1>
        </div>
      </div>
    </section>
  );
}
